import React, { Fragment } from "react";

import { Col, Divider, Row } from "antd";
import { useNavigate } from "react-router-dom";

import Container from "@/components/container/Container";
import CardComponent from "@/components/card";

import IconFilter from "@/components/icons/IconFilter";
import IconPen from "@/components/icons/IconPen";
import IconUserProfile from "@/components/icons/IconUserProfile";
import IconSchoolCollege from "@/components/icons/IconSchoolCollege";
import IconTravelLang from "@/components/icons/IconTravelLang";
import IconConnections from "@/components/icons/IconConnections";

import "@/styles/pages/profile/profile.scss";
import { getUserInfo, setCurrentForm, setModalOpen } from "@/reducers/commonSlice";
import { useDispatch, useSelector } from "react-redux";

const profile = {
  profileImgUrl: "/assets/images/profile.svg",
  firstName: "Roonie",
  lastName: "Shukla",
  role: "Student",
  profileMenus: [
    {
      path: "/profile/study-preferences",
      icon: <IconFilter />,
      profileMenu: "My Study Preferences",
      pen: <IconPen />,
    },
    {
      path: "/profile/basic-contact-information",
      icon: <IconUserProfile />,
      profileMenu: "Profile Information",
      pen: <IconPen />,
    },
    {
      path: "/profile/advance-career-information",
      icon: <IconSchoolCollege />,
      profileMenu: "Career & Education",
      pen: <IconPen />,
    },
    {
      path: "/profile/travel-details",
      icon: <IconTravelLang />,
      profileMenu: "Travel Details",
      pen: <IconPen />,
    },
    {
      path: "/profile/referee-details",
      icon: <IconConnections />,
      profileMenu: "Referee Details",
      pen: <IconPen />,
    },
  ],
};

const Profile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = useSelector(getUserInfo);
  console.log("userData", userData);

  const gotoMenu = (path) => {
    navigate(path);
  };
  const onBecomeGuideClick = () => {
    dispatch(setCurrentForm("applyForGuide"));
    dispatch(setModalOpen(true));
  };

  return (
    <Fragment>
      <div className="profile-page">
        <Container>
          <CardComponent>
            <div className="options-container">
              <Row>
                <Col xxl={24}>
                  <div className="heading">
                    <div className="title-h5-1">My Profile</div>
                  </div>
                </Col>
              </Row>

              <Row gutter={[24, 16]}>
                <Col xxl={3} xl={3} lg={6} md={24} sm={24} xs={24}>
                  <div className="info">
                    <CardComponent>
                      <div className="profile-picture">
                        <img
                          src={
                            userData.profileImgUrl
                              ? userData.profileImgUrl
                              : "/assets/images/defaultProfile.jpeg"
                          }
                          style={{ borderRadius: "50%" }}
                          alt="profile-picture"
                        />
                      </div>
                      <div className="profile-name">
                        <div className="name body-b1">
                          {userData?.user?.firstName} {userData?.user?.lastName}
                        </div>
                        <div className="role body-b5">{profile.role}</div>
                      </div>
                    </CardComponent>
                  </div>
                </Col>
                <Col xxl={21} xl={21} lg={18} md={24} sm={24} xs={24}>
                  <div className="options">
                    <Row gutter={[16, 24]}>
                      {profile?.profileMenus?.map((item, index) => {
                        return (
                          <Fragment key={index}>
                            <Col
                              xxl={8}
                              xl={8}
                              lg={12}
                              md={24}
                              sm={24}
                              xs={24}
                              key={index}
                              onClick={() => gotoMenu(item.path)}
                            >
                              <CardComponent>
                                <div className="option">
                                  <div className="option-content">
                                    <div className="icon">{item.icon}</div>
                                    <div className="option-name body-b3">{item.profileMenu}</div>
                                  </div>
                                  <div className="pen-icon">{item.pen}</div>
                                </div>
                              </CardComponent>
                            </Col>
                          </Fragment>
                        );
                      })}
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>
            {userData?.stage
              ?.toLowerCase()
              .split(" ")
              .map((x) => x.charAt(0).toUpperCase() + x.slice(1))
              .join("") === "AlreadyAtUniversity" &&
            !userData?.roles?.some((item) => item.name === "Guide") ? (
              <>
                <Divider />
                <div className="promotion">
                  <Row>
                    <Col xxl={24}>
                      <CardComponent>
                        <div className="content">
                          <Row gutter={[0, 16]}>
                            <Col xxl={18} xl={18} lg={12} md={24} sm={24} xs={24}>
                              <div className="message body-b2-1">
                                mentor others to study abroad and assist hundreds of students on our
                                platform!
                              </div>
                            </Col>
                            <Col xxl={6} xl={6} lg={12} md={24} sm={24} xs={24}>
                              <div className="apply">
                                <CardComponent onClick={() => onBecomeGuideClick()}>
                                  <div className="option">
                                    <div className="option-content">
                                      <div className="icon">
                                        <IconSchoolCollege />
                                      </div>
                                      <div className="option-name body-b3">Become a Guide</div>
                                    </div>
                                    <div className="next-icon body-b1">&gt;</div>
                                  </div>
                                </CardComponent>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </CardComponent>
                    </Col>
                  </Row>
                </div>
              </>
            ) : (
              <></>
            )}
          </CardComponent>
        </Container>
      </div>
    </Fragment>
  );
};

export default Profile;
